import { default as defaultPreset } from '../presets/default.json';
import { default as dsPreset } from '../presets/ds.json';
import { default as editorPreset } from '../presets/editor.json';
import { default as boltPreset } from '../presets/bolt.json';
import { default as ooiPreset } from '../presets/ooi.json';
import { default as mobilePreset } from '../presets/mobile.json';
import { presetsTypes } from '../presets/presets-types';
export function presetLoader(presetType) {
    switch (presetType) {
        case presetsTypes.DEFAULT:
            return defaultPreset;
        case presetsTypes.BOLT:
            return boltPreset;
        case presetsTypes.DS:
            return dsPreset;
        case presetsTypes.EDITOR:
            return editorPreset;
        case presetsTypes.OOI:
            return ooiPreset;
        case presetsTypes.MOBILE:
            return mobilePreset;
        default:
            return defaultPreset;
    }
}
//# sourceMappingURL=loader.js.map